import { render, staticRenderFns } from "./facebook-like-sv3.vue?vue&type=template&id=6e67906b&"
import script from "./facebook-like-sv3.vue?vue&type=script&lang=js&"
export * from "./facebook-like-sv3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports